module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Clerk"},"no":{"title":"Ansvarlig"}}')
  delete Component.options._Ctor
}
